export function getEnv() {
  if (process.env.NEXT_PUBLIC_ENV === 'staging') {
    return 'staging';
  }

  if (process.env.NEXT_PUBLIC_ENV === 'production') {
    return 'production';
  }

  if (process.env.NEXT_PUBLIC_ENV === 'dev') {
    return 'dev';
  }

  if (process.env.NEXT_PUBLIC_ENV === 'local') {
    return 'local';
  }

  return 'unknown';
}

export function isClient() {
  return typeof window !== 'undefined';
}

export function isServer() {
  return typeof window === 'undefined';
}

export function isProduction() {
  return getEnv() === 'production';
}

export function isDevelopment() {
  return getEnv() === 'dev';
}

export function isTest() {
  return getEnv() === 'staging';
}

export function isLocal() {
  return getEnv() === 'local';
}
